import { useState } from "react";

const heroImage =
  "https://readdy.ai/api/search-image?query=Dark%20artistic%20anime%20game%20key%20visual%20with%20crimson%20and%20gold%20neon%20glow%2C%20silhouettes%20of%20characters%20amid%20floating%20particles%20and%20cherry%20blossoms%2C%20moody%20cinematic%20gaming%20atmosphere%2C%20rich%20dark%20warm%20palette%2C%20abstract%20stylized%20background%2C%20high%20detail%20digital%20artwork&width=1600&height=900&seq=eroge-hero-2026&orientation=landscape";

export default function Hero() {
  const [query, setQuery] = useState("");

  const search = () => {
    const keyword = query.trim() || "排行榜";
    const el = document.querySelector("#beginner");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    // simple highlight: store keyword for demo
    window.dispatchEvent(new CustomEvent("site-search", { detail: keyword }));
  };

  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImage} alt="工口游戏推荐站暗色艺术背景图" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-28 md:py-36 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/30 text-accent-500 text-xs md:text-sm mb-6">
          <i className="ri-fire-line" />
          工口游戏入门 · 排行 · 神作盘点 一站看全
        </span>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-950 leading-tight tracking-wide">
          想玩好玩的<em className="not-italic text-accent-400">工口游戏</em>
          <br />
          却不知道从哪下手？
        </h1>

        <p className="mt-6 text-sm md:text-base text-foreground-300 max-w-2xl leading-7">
          本站整理工口游戏推荐、排行榜、神作盘点与口碑评测，从入门到进阶全都有，帮你快速锁定对胃口的作品，少走弯路。
        </p>

        <div className="mt-9 w-full max-w-xl">
          <form
            className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-0 bg-background-100/90 backdrop-blur border border-background-200/60 rounded-full p-1.5 sm:pr-1.5"
            onSubmit={(e) => {
              e.preventDefault();
              search();
            }}
          >
            <label className="flex-1 flex items-center gap-3 px-4 py-2.5">
              <i className="ri-search-line text-foreground-500 text-base" />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索想找的工口游戏题材、类型…"
                className="flex-1 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-500"
              />
            </label>
            <button
              type="submit"
              className="px-6 py-2.5 rounded-full bg-primary-500 text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始探索
            </button>
          </form>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <button onClick={() => go("#beginner")} className="px-4 py-2 rounded-full bg-background-100/70 border border-background-200/60 text-foreground-800 text-xs hover:bg-accent-500/20 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
            新手入门推荐
          </button>
          <button onClick={() => go("#ranking")} className="px-4 py-2 rounded-full bg-background-100/70 border border-background-200/60 text-foreground-800 text-xs hover:bg-accent-500/20 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
            口碑排行榜
          </button>
          <button onClick={() => go("#masterpiece")} className="px-4 py-2 rounded-full bg-background-100/70 border border-background-200/60 text-foreground-800 text-xs hover:bg-accent-500/20 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
            神作盘点
          </button>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-6 w-full max-w-3xl">
          {[
            { num: "500+", label: "收录作品" },
            { num: "360+", label: "深度评测" },
            { num: "28", label: "题材分类" },
            { num: "9.6", label: "社区平均口碑" },
          ].map((s) => (
            <div key={s.label} className="rounded-xl bg-background-100/70 border border-background-200/50 px-3 py-4 backdrop-blur">
              <p className="font-heading text-2xl md:text-3xl text-accent-400">{s.num}</p>
              <p className="text-xs text-foreground-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}